import { Pagination } from "@tryghost/content-api";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { VerticalSpacing } from "../VerticalSpacing";
import { PaginationArrow, PaginationNumber, PaginationWrapper } from "./BlogPagination.styles";

const getPageRoute = (url: string, page: number, paginationPrefix = "") =>
    page === 1 ? `${paginationPrefix || url}` : `${paginationPrefix || url}/page/${page}`;

interface BlogPaginationProps {
    pagination: Pagination;
    paginationPrefix?: string;
    url?: string;
}

export const BlogPagination = ({ pagination, paginationPrefix, url = APPLICATION_ROUTES.BLOG }: BlogPaginationProps) => {
    if (pagination.total === 0) return null;

    if (pagination.pages === 1) return null;

    const PageOffSet = 2;
    const pages = Array.from(Array(pagination.pages).keys()).map((key) => key + 1);
    const minPage = Math.max(0, pagination.page - PageOffSet);
    const maxPage = Math.min(pagination.pages, pagination.page + PageOffSet - 1);
    const slicedPages = pages.slice(minPage, maxPage);

    return (
        <VerticalSpacing top={96} bottom={96}>
            <PaginationWrapper>
                {pagination.prev && (
                    <div>
                        <UnstyledLink href={getPageRoute(url, pagination.prev, paginationPrefix)} aria-label="link to previous page">
                            <PaginationArrow src="/authory_static_files/images/chevron-left.svg" alt="prev arrow" />
                        </UnstyledLink>
                    </div>
                )}
                {slicedPages.length > 1 &&
                    slicedPages.map((page, index) => (
                        <UnstyledLink href={getPageRoute(url, page, paginationPrefix)} key={page}>
                            <PaginationNumber key={index} selected={pagination.page === page}>
                                {page}
                            </PaginationNumber>
                        </UnstyledLink>
                    ))}
                {pagination.next && (
                    <UnstyledLink href={getPageRoute(url, pagination.next, paginationPrefix)} aria-label="link to next page">
                        <PaginationArrow src="/authory_static_files/images/chevron-right.svg" alt="next arrow" />
                    </UnstyledLink>
                )}
            </PaginationWrapper>
        </VerticalSpacing>
    );
};
